import { handleAsyncUpdateBulkImport } from './handle-async-update'

import {
  logGenerateAnswersFail,
  logGenerateAnswersSuccess,
  logGenerateCorrectAnswersSuccess,
  logGenerateCorrectAnswersFail,
  logGenerateCriteriaWithAiFail,
  logGenerateCriteriaWithAiSuccess,
  logGenerateTranslationsFail,
  logGenerateTranslationsSuccess,
} from '@/lib/firebase_analyics/bulk-import-analytics'
import { type CardActivityWithId } from '@/models/card-activity/card-activity.model'

export async function handleUpdateAICalls(
  currentCards: Map<string, CardActivityWithId>,
  instructions: {
    cardId: string
    fieldToUpdate: 'grading_method' | 'native_text' | 'choices' | 'image.url' | 'correct_answer'
    updates: any
  }[],
) {
  const updatedCards = new Map(currentCards)

  try {
    const updatePromises = instructions.map(async ({ cardId, fieldToUpdate, updates }) => {
      const card = updatedCards.get(cardId)!
      const newCardObject = await handleAsyncUpdateBulkImport(card, fieldToUpdate, updates)

      return { cardId, newCardObject }
    })

    const results = await Promise.all(updatePromises)

    results.forEach(({ cardId, newCardObject }) => {
      updatedCards.set(cardId, newCardObject)
    })

    successLogs(instructions[0].fieldToUpdate, currentCards.size)

    return updatedCards
  } catch (error) {
    failLogs(instructions[0].fieldToUpdate, currentCards.size)

    console.error('Error updating cards', error)

    return currentCards
  }
}

const successLogs = (
  fieldToUpdate: 'grading_method' | 'native_text' | 'choices' | 'image.url' | 'correct_answer',
  numberOfCards: number,
) => {
  if (fieldToUpdate === 'grading_method') {
    logGenerateCriteriaWithAiSuccess({
      numberOfCards,
    })
  }

  if (fieldToUpdate === 'native_text') {
    logGenerateTranslationsSuccess({
      numberOfCards,
    })
  }

  if (fieldToUpdate === 'choices') {
    logGenerateAnswersSuccess({
      numberOfCards,
    })
  }

  if (fieldToUpdate === 'correct_answer') {
    logGenerateCorrectAnswersSuccess({
      numberOfCards,
    })
  }
}

const failLogs = (
  fieldToUpdate: 'grading_method' | 'native_text' | 'choices' | 'image.url' | 'correct_answer',
  numberOfCards: number,
) => {
  if (fieldToUpdate === 'grading_method') {
    logGenerateCriteriaWithAiFail({
      numberOfCards,
    })
  }

  if (fieldToUpdate === 'native_text') {
    logGenerateTranslationsFail({
      numberOfCards,
    })
  }

  if (fieldToUpdate === 'choices') {
    logGenerateAnswersFail({
      numberOfCards,
    })
  }

  if (fieldToUpdate === 'correct_answer') {
    logGenerateCorrectAnswersFail({
      numberOfCards,
    })
  }
}
